import { isValidLocale } from "../localization";

export const getProgressivePathSegments = (path: string) => {
    let proPath = "/";

    if (!path || !path.startsWith("/")) {
        return [];
    }

    return path
        .split("/")
        .filter(Boolean) // remove empty array elements
        .filter((p) => !isValidLocale(p))
        .map((value) => {
            proPath += `${value}/`;
            return proPath.replace(/\/$/, "");
        });
};
